export default "__VITE_ASSET__89b0082e__"